import { render, staticRenderFns } from "./float_nav.vue?vue&type=template&id=67b8c0b4&scoped=true&"
import script from "./float_nav.vue?vue&type=script&lang=js&"
export * from "./float_nav.vue?vue&type=script&lang=js&"
import style0 from "./float_nav.vue?vue&type=style&index=0&id=67b8c0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b8c0b4",
  null
  
)

export default component.exports